export type TAppState = 'start'|'question'|'result';

export class AppState {
    public static START: TAppState = 'start';
    public static QUESTION: TAppState = 'question';
    public static RESULT: TAppState = 'result';

    constructor() {
        throw new Error('Do not instantiate this class!');
    }
}



// WEBPACK FOOTER //
// ./src/app/app-state.ts